<div class="station is-flex gap-4 is-space-between bg-grey-hover-10 radius-8">
  <div class="is-flex">
    @if (home().mode === 'favorite') {
      <app-text class="text-14 is-family-semiBold text-grey-70 ellipsis" [text]="name()" />
    }
    @else {
      <app-text class="text-14 is-family-semiBold text-grey-70 is-flex-shrink-0" [text]="name()"/>
      &nbsp;
      <app-text class="text-12 is-family-semiBold text-grey-70 ellipsis" [text]="'(' + home().name + ')'" />
    }
  </div>
  <div class="is-flex gap-8 is-flex-shrink-0">
    <div class="is-flex gap-4">
      <app-icon class="text-blue" name="temperature-16"/>
      <div class="is-flex">
        <app-text class="text-14 is-family-semiBold text-blue" [text]="(outdoorModule().Temperature | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE) ?? '--'" />
        &nbsp;
        <app-text class="text-12 is-family-semiBold text-grey-70" unit [measureType]="EnumMeasureTypes.TEMPERATURE"/>
      </div>
    </div>
    <div class="is-flex gap-4">
      <app-icon class="text-blue" name="humidity-16"/>
      <div class="is-flex">
        <app-text class="text-14 is-family-semiBold text-blue" [text]="(outdoorModule().Humidity | toDisplayValue : EnumMeasureTypes.HUMIDITY) ?? '--'" />
        &nbsp;
        <app-text class="text-12 is-family-semiBold text-grey-70" unit [measureType]="EnumMeasureTypes.HUMIDITY"/>
      </div>
    </div>
  </div>
</div>